export interface OrderGetDataBase {
  data: OrderItem[]
}

export interface OrderItem {
  ID: string
  CreatedAt: string
  UpdatedAt?: string
  DeletedAt?: string
  created_by: string
  updated_by?: string
  ICCID: string
  userName: string
  userEmail: string
  packageTypeID: number
  paymentID: string
  paymentStatus: OrderChangeState
}

/* List of possible order states */
export enum OrderChangeState {
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
  OTHERS = 'NULL'
}
